import { useFlightTimes } from "../_hooks/useFlightTimes";

export const delay = (ms: any) =>
  new Promise((resolve) => setTimeout(resolve, ms));

export const getSelectedItems = (
  array: any[] = [],
  selectionProperty = "isSelected"
) => {
  return array?.filter((item) => item[selectionProperty]) ?? [];
};

export const getFieldError = <T>(
  errors: any,
  index: number,
  field: keyof T
) => {
  if (!errors || !errors[index]) return undefined;
  const error = errors[index][field];
  return typeof error === "string" ? error : undefined;
};

export const isFormikErrorsArray = <T>(errors: any): errors is any[] => {
  return Array.isArray(errors);
};

export const getFlightTimes = (flights: any[] = []) => {
  return flights?.map((flight: any) => useFlightTimes(flight?.route || {}));
};

export const getTotalSegmentsSum = (flights: any = []) => {
  return flights?.reduce(
    (total: any, flightObj: any) =>
      total + (flightObj.Flight?.Segments?.length || 0),
    0
  );
};

export const generateRequestId = (): string => {
  const Request_Id =
    "REQ-" +
    Date.now().toString(36) +
    "-" +
    Math.random().toString(36).substring(2, 10).toUpperCase();
  sessionStorage.setItem("request_id", Request_Id);
  return Request_Id;
};

export const getRequestId = (): string => {
  const Request_Id = sessionStorage.getItem("request_id");
  if (Request_Id) {
    return Request_Id;
  } else {
    const newRequestId =
      "REQ-" +
      Date.now().toString(36) +
      "-" +
      Math.random().toString(36).substring(2, 10).toUpperCase();
    return newRequestId;
  }
};
